import React from 'react';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import tc from 'tinycolor2';
import { colors } from '../../styles';

const styles = css`
  display: none;
  @media (min-width: 1200px) {
    display: block;
    position: relative;
    z-index: 1;
    width: fit-content;
  }
  .CourtesyNav {
    display: none;
    @media (min-width: 1200px) {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 40px 0 0;
      position: fixed;
      width: 100%;
      margin: 0;
      transition: all .3s ease;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${tc(colors.brand4).setAlpha(0.8).toRgbString()};
        z-index: -1;
      }
    }
    @media (min-width: 1600px) {
      padding: 0 80px 0 0;
    }
  }
  .CourtesyNav_item {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    width: fit-content;
    &:not(:first-child) {
      margin: 0 0 0 25px;
    }
    img {
      margin: -2px 9px 0 0;
      height: 20px;
      width: auto;
      display: inline-block;
    }
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      color: ${colors.white};
      font-size: 15px;
      line-height: 1;
      font-weight: 600;
      padding: 0;
      height: 45px;
    }
    .FavoritesStatus-active {
      @media (min-width: 1200px) {
        display:inline-block;
        position:relative;
        padding:0;
        background: none;
      }
    }
  }
  .ToggleNav_menuHeading {
    display:none;
  }
`;

function CourtesyNav() {
  return (
    <div className={styles} >
      <ul className="CourtesyNav">
        <li className="CourtesyNav_item"><Link name="service-request" className="CourtesyNav_itemLink"><img src="/images/icon-service-light-blue.svg" alt="" /><span>Service Request</span></Link></li>
        <li className="CourtesyNav_item"><Link name="photo-gallery" className="CourtesyNav_itemLink"><img src="/images/icon-photo-gallery-light-blue.svg" alt="" /><span>Photo Gallery</span></Link></li>
        <li className="CourtesyNav_item"><Link name="elliott-advantage" className="CourtesyNav_itemLink"><img src="/images/icon-checklist-light-blue.svg" alt="" /><span>The Elliott Advantage</span></Link></li>
        <li className="CourtesyNav_item"><Link name="schedule-appointment" className="CourtesyNav_itemLink"><img src="/images/icon-calendar-light-blue.svg" alt="" /><span>Schedule Appointment</span></Link></li>
      </ul>
    </div>
  );
}

export default CourtesyNav;



// WEBPACK FOOTER //
// ./src/components/Header/CourtesyNav.js